export default __webpack_public_path__ + "assets/images/ff5a34a19c3fada68945447531a8e8bb.svg";